module.exports = __webpack_public_path__ + "static/img/portrait.90b87fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portrait.png
// module id = ycxP
// module chunks = 1